export enum LoanInformationVariables {
  LoanAmount = 'Loan Amount',
  LoanType = 'Loan Type',
  LoanPurpose = 'Loan Purpose',
  OtherHomeImprovementType = 'Other Home Improvement(s) Type',
  BorrowerCellPhone = 'Borrower Cell Phone',
  BorrowerEmail = 'Borrower Email',
  BorrowerDateOfBirth = 'Borrower Date of Birth',
  CoBorrowerCellPhone = 'Cell Phone',
  CoBorrowerEmail = 'Email',
  CoBorrowerDateOfBirth = 'Date of Birth',
  FirstName = 'First Name',
  LastName = 'Last Name',
  HomeStreetAddress = 'Home Street Address',
  City = 'City',
  State = 'State',
  ZipCode = 'Zip Code',
  County = 'County',
  SSN = 'SSN',
  SessionId = 'SessionId',
  IsBorrowerManualFlow = 'IsBorrowerManualFlow',
  IsCoBorrowerManualFlow = 'IsCoBorrowerManualFlow',
  CoBorrowerFirstName = 'First Name',
  CoBorrowerLastName = 'Last Name',
  CoBorrowerSSN = 'SSN',
  ProcessingStatusSetDate = 'Processing Status Set Date',
  AssignedConsultant = 'Assigned Consultant',
  AssignedProcessor = 'Assigned Processor',
  BorrowerChangedInfoAfterProvePreFill = 'BorrowerChangedInfoAfterProvePreFill',
  CoBorrowerChangedInfoAfterProvePreFill = 'CoBorrowerChangedInfoAfterProvePreFill',
  SwimmingPoolType = 'Swimming Pool Type',
  OwnershipStatus = 'Ownership Status',
  PurchaseDate = 'Purchase Date',
  FullConsentCheckbox = 'Full Consent Checkbox',
  CoBorrowerIncome = 'CoBorrowerIncome',
}
